module.exports = __webpack_public_path__ + "static/media/picture-(266).75fcc984.JPG";